import { rupiah } from 'lib/currency';
import { findValidForClass, findColorType, formatTitleByWord } from 'lib/uiHelpers';

const CardClass = ({ item, onQuickView, onCheckout, context = 'list', hideBuyButton = false }) => {
  if (!item) {
    return (
      <div className="flex items-center justify-center py-8 text-gray-400 text-sm">
        No class data available
      </div>
    );
  }

  const goToCheckout = (id) => {
    onCheckout(id);
  };

  const borderStyle = 'border-gray-200 hover:border-primary-main/80 hover:shadow-lg';
  const bgStyle = 'bg-white text-kin-text';

  return (
    <div
      className={`group relative flex flex-col justify-between h-full 
      rounded-3xl border-2 ${borderStyle} ${bgStyle} 
      overflow-hidden cursor-pointer transition-all duration-300 
      px-6 py-8`}>
      {/* Tag */}
      <div className="absolute top-0 right-0">
        <div
          className={`${findColorType(
            item.type.toLowerCase(),
          )} px-3 py-1.5 rounded-bl-2xl rounded-tr-2xl`}>
          <span className="text-sm font-semibold text-white capitalize">
            {item.type.toLowerCase() === 'collaboration' ? item.type : `${item.type} Class`}
          </span>
        </div>
      </div>

      {/* Content */}
      <div className="flex flex-col gap-2 items-start flex-grow">
        <p className="font-light text-sm leading-none text-kin-text/80">
          {item.type === 'Regular' ? 'CLASS PASS' : 'SPECIAL CLASS PASS'}
        </p>

        <h3 className="capitalize text-lg font-bold text-kin-text leading-tight min-h-[60px] max-w-[300px] overflow-hidden line-clamp-2 break-words">
          {formatTitleByWord(item.package_name || '-')}
        </h3>

        <span className="font-semibold text-base">{item.price ? rupiah(item.price) : 'Rp 0'}</span>

        {/* Details */}
        <div className="bg-kin-main p-3 rounded-lg w-full text-left">
          <ul className="flex flex-col gap-2">
            <CardFeature icon="/kin/assest/image/icon-dollar.svg" label="One Time Payment" />
            <CardFeature
              icon="/kin/assest/image/icon-star.svg"
              label={`Valid for any ${findValidForClass(item.type.toLowerCase())}`}
            />
            <CardFeature
              icon="/kin/assest/image/icon-calender.svg"
              label={`Valid on ${
                item.validity_period_month !== 0
                  ? `${item.validity_period_month} Month`
                  : 'Everyday'
              }`}
            />
            <CardFeature
              icon="/kin/assest/image/icon-clock.svg"
              label={`Valid for ${
                item.credit_number > 1
                  ? `${item.credit_number} Classes`
                  : `${item.credit_number} Class`
              }`}
            />
          </ul>

          {/* Quick View (desktop only) */}
          {onQuickView && context === 'list' && (
            <span
              onClick={(e) => {
                e.stopPropagation();
                onQuickView(item);
              }}
              className="hidden md:block text-sm text-primary-main font-semibold mt-2 cursor-pointer hover:underline">
              Quick View
            </span>
          )}
        </div>
      </div>

      {/* Button Section */}
      {!hideBuyButton && (
        <div className="flex flex-col gap-2 mt-4">
          <button
            onClick={(e) => {
              e.stopPropagation();
              goToCheckout(item.id);
            }}
            className="bg-primary-main text-white hover:bg-primary-dark cursor-pointer inline-flex items-center justify-center gap-1 rounded-3xl px-5 py-2 text-xs font-semibold transition-all duration-300 self-start">
            BUY NOW
          </button>
        </div>
      )}
    </div>
  );
};

/** Small clean subcomponent */
const CardFeature = ({ icon, label }) => (
  <li className="flex flex-row items-center font-medium gap-1 text-kin-text text-sm">
    <div className="w-4 h-4 relative flex-shrink-0">
      <img alt="icon" src={icon} className="absolute inset-0 h-full w-full object-cover" />
    </div>
    <span>{label}</span>
  </li>
);

export default CardClass;
